export { default } from './TabsBlock';
